import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { RelevancySummaryPopupContent } from '../relevancy-summary-popup-content';
import { RelevancySummaryPopupHeader } from '../relevancy-summary-popup-header';
import * as Styled from './styles';
import * as SX from './sx';
import type { RelevancySummaryPopupProps as Props } from './types';

const ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'center',
} as const;
const TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'center',
} as const;

export const RelevancySummaryPopup = memo(
  ({ className, state, relevancy }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('RelevancySummaryPopup', className)}
        sx={SX.root}
        contentSx={SX.content}
        state={state}
        anchorOrigin={ANCHOR_ORIGIN}
        transformOrigin={TRANSFORM_ORIGIN}
      >
        <RelevancySummaryPopupHeader relevancy={relevancy} />
        <RelevancySummaryPopupContent />
      </Styled.Wrapper>
    );
  }
);

RelevancySummaryPopup.displayName = 'RelevancySummaryPopup';
